export default "2c09f6ce458439f7.svg"